/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvitationAcceptResponse
 */
export interface InvitationAcceptResponse {
    /**
     * 
     * @type {boolean}
     * @memberof InvitationAcceptResponse
     */
    success: boolean;
    /**
     * 
     * @type {number}
     * @memberof InvitationAcceptResponse
     */
    orgId: number;
    /**
     *
     * @type {boolean}
     * @memberof InvitationAcceptResponse
     */
    joinOnboardingPending: boolean;
    /**
     *
     * @type {string}
     * @memberof InvitationAcceptResponse
     */
    message: string;
}

/**
 * Check if a given object implements the InvitationAcceptResponse interface.
 */
export function instanceOfInvitationAcceptResponse(value: object): value is InvitationAcceptResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('orgId' in value) || value['orgId'] === undefined) return false;
    if (!('joinOnboardingPending' in value) || value['joinOnboardingPending'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function InvitationAcceptResponseFromJSON(json: any): InvitationAcceptResponse {
    return InvitationAcceptResponseFromJSONTyped(json, false);
}

export function InvitationAcceptResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationAcceptResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'orgId': json['org_id'],
        'joinOnboardingPending': json['join_onboarding_pending'],
        'message': json['message'],
    };
}

  export function InvitationAcceptResponseToJSON(json: any): InvitationAcceptResponse {
      return InvitationAcceptResponseToJSONTyped(json, false);
  }

  export function InvitationAcceptResponseToJSONTyped(value?: InvitationAcceptResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'org_id': value['orgId'],
        'join_onboarding_pending': value['joinOnboardingPending'],
        'message': value['message'],
    };
}

